import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import HomePage from './HomePage';
import RRM from './rrm/RRM';
import SignInPage from './unAuth/SignInPage';
import SignUpPage from './unAuth/SignUpPage';

const PrivateRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();

  // Optional dev bypass like the original app
  const devBypass = localStorage.getItem('devBypass') === 'true';
  if (devBypass) return children;

  if (loading) return <div style={{ padding: 24 }}>Loading…</div>;
  return currentUser ? children : <Navigate to="/signin" replace />;
};

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/signin" element={<SignInPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route
            path="/rrm"
            element={
              <PrivateRoute>
                <RRM />
              </PrivateRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}


